import React, { Fragment } from 'react';
import { Translation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { mapStateToProps } from 'root/redux/selector/selector';
import { withRouter } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import SortItem from './SortItem';
import BrandList from './BrandList';
import GameList from './GameList';
import { path } from 'ramda';
import Loading from 'root/components/Loading/Loading';
import MessagePopUp from 'root/components/MessagePopUp';
import SVGElements from 'root/components/SVGElements';
import SVGElementsOwn from 'root/components/SVGElementsOwn';
import { portalAction } from 'root/redux/action/index';
import SVG from 'react-inlinesvg';

class Search extends React.Component {
    isMount = true;
    constructor(props) {
        super(props);
        this.state = {
            // brandName: "",
            page: 'brand',
            menus: [],
            submenus: [],
            displaySubmenu: [],
            recommendSlideRow: 1,
            brand: 'NS',
            slotCategory: [],
            slotGamesList: [],
            provider: '',
            loading: false,
            isLoading: false,
            list: [],
            dropDownItem1: 'ALL',
            dropDownItem2: 'global:global.none',
            favoritedGame: [],
            searchValue: '',
            loginModal: false,
            detailModal: false,
            selectedGameObj: null,
        };
        this.toggleDetailModal = this.toggleDetailModal.bind(this);
    }

    // Desktop Function
    componentDidMount() {
        this.isMount = true;
        this.getDisplayMenu();
        this.getDisplaySubCategory();
        // this.init();
    }

    componentWillUnmount() {
        this.isMount = false;
    }

    toggleDetailModal = () => {
        this.setState({
            detailModal: !this.state.detailModal,
        });
    };

    getDisplayMenu = () => {
        const { language } = this.props;
        let screen = '';

        if (this.props.screen.isMobile) {
            screen = 'mobile';
        } else {
            screen = 'web';
        }

        window.SPL_Content.getDisplayMenu(language.countryLanguageKey, screen).then((data) => {
            if (this.isMount) {
                this.setState({ menus: data });
            }
        });
    };

    getDisplaySubCategory = () => {
        const { language } = this.props;
        let screen = '';

        if (this.props.screen.isMobile) {
            screen = 'mobile';
        } else {
            screen = 'web';
        }

        let loadGetDisplaySubCategory = new Promise((resolve) => {
            window.SPL_Content.getDisplaySubCategory(language.countryLanguageKey, screen).then((data) => resolve(data));
        });

        let loadProviderGameMaintenanceList = new Promise((resolve) => {
            window.SPL_Provider.providerGameMaintenanceList(null, null, language.currencyLang).then((result) => resolve(result));
        });

        Promise.all([loadGetDisplaySubCategory, loadProviderGameMaintenanceList]).then((loadResult) => {
            let subCategory = loadResult[0];
            let providerMaintenance = loadResult[1];

            if (this.isMount) {
                this.setState({ submenus: subCategory }, () => {
                    let displaySubmenuObj = this.state.submenus.filter((s) => s.link === 'SL')[0];
                    let displaySubmenu = [];

                    if (displaySubmenuObj) {
                        displaySubmenu = displaySubmenuObj.submenu;
                    }

                    for (let i = 0; i < displaySubmenu.length; i++) {
                        let provider = displaySubmenu[i].provider;

                        if (!providerMaintenance) continue;
                        for (let j = 0; j < providerMaintenance.length; j++) {
                            let maintenanceProvider = providerMaintenance[j].provider;

                            if (provider === maintenanceProvider) {
                                displaySubmenu[i].underMaintenance = providerMaintenance[j];
                            }
                        }
                    }

                    this.setState({ displaySubmenu: displaySubmenu }, () => {
                        let submenu = this.state.displaySubmenu;

                        for (let i = 0; i < submenu.length; i++) {
                            if (screen === 'mobile' && submenu[i].route === this.props.location.pathname) {
                                this.setState({ brand: submenu[i].provider, page: 'games' }, () => {
                                    // this.props.history.push(submenu[i].route);
                                });
                            } else if (submenu[i].route === this.props.location.pathname) {
                                this.setState({ brand: submenu[i].provider }, () => {
                                    // this.props.history.push({ pathname: submenu[i].route, state: { slotBrand: false } });
                                    this.init(this.state.brand);
                                });
                            }
                        }
                    });
                });
            }
        });
    };

    init = (item) => {
        if (this.isMount) {
            this.setState({ provider: item }, () => {
                if (item === '') {
                    this.props.history.push('/home');
                } else if (item === 'UL') {
                    const { screen } = this.props;

                    if (screen.isMobile) {
                        this.navigateToHome();
                    }
                } else {
                    this.getDefaultTab(() => {
                        this.getSlotGames(this.state.dropDownItem1);
                    });
                }
            });
        }
    };

    getDefaultTab = (callback) => {
        const { provider } = this.state;
        // all WhiteLabel required set NS default tab as hot
        let defaultTab = 'ALL';
        if (provider === 'NS') {
            defaultTab = 'HOT';
        }

        //dropDownItem1
        this.setState({ dropDownItem1: defaultTab }, () => {
            callback && callback();
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.state.provider !== prevState.provider || prevProps.screen.isMobile !== this.props.screen.isMobile) {
            this.getDefaultTab(() => {
                this.getSlotGames(this.state.dropDownItem1);
            });
        }

        let provider = this.state.brand;
        const pathParts = this.props.location.pathname.split('/');

        if (prevState.provider !== provider) {
            if (this.isMount) {
                this.setState({ provider: provider }, () => {
                    this.handleSearch('', this.state.dropDownItem1);
                    // this.getSlotGames(this.state.dropDownItem1);
                });
            }
        }

        //Fixing mobile display issue with incorrect content when clicking menu
        if (prevProps.location.pathname !== this.props.location.pathname && pathParts.length === 2) {
            // Split the path and get the last part
            const endpoint = pathParts[pathParts.length - 1];

            if (endpoint) {
                this.setState({ page: 'brand' });
            }
        }
    }

    getSlotGames = (filter, keyword) => {
        // query from url params
        const { screen } = this.props;
        const { provider } = this.state;
        let loading = true;
        keyword = keyword ? keyword : '';

        if (keyword !== '') {
            // if handle search game with keyword, no need loading
            loading = false;
        }

        if (this.isMount) {
            if (provider !== 'UL') {
                this.setState({ isLoading: loading }, () => {
                    window.SPL_Content.getAllSlotGames(screen.viewType, true, provider, filter, keyword)
                        .then((data) => {
                            if (this.isMount) {
                                this.setState(
                                    (prevState) => {
                                        if (prevState.dropDownItem1 === filter && keyword === prevState.searchValue)
                                            return { slotCategory: data.slotCategory, slotGamesList: data.displayGames, isLoading: false };
                                    },
                                    () => {
                                        this.chdName();
                                        this.getMemberFavoriteGame();

                                        if (this.state.dropDownItem2 !== 'global:global.none') {
                                            this.slotSorting(this.state.dropDownItem2);
                                        }
                                    }
                                );
                            }
                        })
                        .catch((err) => {
                            if (this.isMount) {
                                this.setState({ isLoading: false });
                            }
                        });
                });
            } else {
                this.setState({ isLoading: loading }, () => {
                    if (this.isMount) {
                        this.setState({ isLoading: false });
                    }
                });
            }
        }
    };

    getMemberFavoriteGame = () => {
        const { screen, language } = this.props;

        let isMobile = null;
        if (screen.viewType === 'web') {
            isMobile = false;
        } else {
            isMobile = true;
        }

        let hotGame = this.state.slotGamesList;
        if (hotGame?.length <= 0) return;
        for (let a = 0; a < hotGame.length; a++) {
            hotGame[a].isFavourite = false;
        }

        window.SPL_Provider.providerGameMaintenanceList(null, null, language.currencyLang).then((result) => {
            let hotGame = this.state.slotGamesList;
            for (let a = 0; a < hotGame.length; a++) {
                hotGame[a].isFavourite = false;
                let provider = hotGame[a].provider;

                if (!result) continue;
                for (let j = 0; j < result.length; j++) {
                    let maintenanceProvider = result[j].provider;

                    if (provider === maintenanceProvider) {
                        hotGame.underMaintenance = result[j].gameMaintenance;
                    }
                }
            }

            this.setState({ slotGamesList: hotGame });
        });

        window.SPL_Member.getMemberFavoriteGame(isMobile).then((data) => {
            this.setState({ favoritedGame: data.favoritedGame }, () => {
                this.applyFavourite();
            });
        });
    };

    updateMemberFavoriteGame = (game) => {
        this.setState({ loading: true });
        const { screen } = this.props;
        const { isLogin } = this.props.user;
        const { favoritedGame } = this.state;

        let isMobile = null;
        if (screen.viewType === 'web') {
            isMobile = false;
        } else {
            isMobile = true;
        }

        if (!isLogin) {
            this.setState({ detailModal: true, loginModal: true, loading: false }, () => {
                this.loginMsg();
            });
        } else {
            this.setState({ detailModal: false, loginModal: false });
            let delelteGame = false;
            for (let i = 0; i < favoritedGame.length; i++) {
                if (favoritedGame[i].game === game.game) {
                    delelteGame = true;
                }
            }

            if (delelteGame === true) {
                window.SPL_Member.deleteMemberFavoriteGame(game, isMobile).then((data) => {
                    this.getMemberFavoriteGame();
                });
            } else {
                window.SPL_Member.updateMemberFavoriteGame(game, isMobile)
                    .then((data) => {
                        this.getMemberFavoriteGame();
                    })
                    .catch(() => {
                        this.setState({ loading: false });
                    });
            }
        }
    };

    loginMsg = () => {
        if (this.state.loginModal) {
            this.setState({ msgTitle: 'login:login.proceed' });
        }
    };

    applyFavourite = () => {
        const { favoritedGame, slotGamesList } = this.state;

        for (let j = 0; j < slotGamesList.length; j++) {
            for (let i = 0; i < favoritedGame.length; i++) {
                if (favoritedGame[i].game === slotGamesList[j].game) {
                    slotGamesList[j].isFavourite = true;
                }
            }
        }

        this.setState({ slotGamesList: slotGamesList, loading: false });
    };

    chdName = () => {
        const { slotCategory } = this.state;
        let slot = slotCategory;

        for (let i = 0; i < slot.length; i++) {
            if (slot[i] === 'HTML5') {
                slot[i] = 'ALL';
            }
        }

        this.setState({ slotCategory: slot });
    };

    navigateToHome = () => {
        const { history } = this.props;
        history.push('/');
    };

    handleBrandChange = (tag, name, route) => {
        let x = window.pageXOffset || document.documentElement.scrollLeft;
        let y = window.pageYOffset || document.documentElement.scrollTop;

        if (!(tag === 'MEGA' || tag === 'SCR' || tag === 'PSY8')) {
            window.scrollTo(x, y);
        }

        this.setState({ brand: tag }, () => {
            const formatNS = tag === 'NS' && route.includes('/slots/nextspin');

            this.props.history.push({
                pathname: formatNS ? `/slots` : route,
                state: { slotBrand: tag },
            });
        });
    };

    onItemClick = (item, i) => {
        if (this.props.screen.isMobile) {
            if (item) {
                item.on = true;
            }

            this.setState({ selectedGameObj: item });
        }
    };

    // Mobile Function
    handleBrandChangeMobile = (tag, name, route) => {
        this.setState({ brand: tag, searchValue: '' });
        if (tag === 'MEGA' || tag === 'SCR' || tag === 'PSY8') {
            // window.history.pushState(null, null, '/' + this.props.language.countryLanguageKey.toLowerCase().replace('_', '-') + route + '?recommend=true');
            this.props.history.push(route + '?recommend=true');
        } else {
            this.setState({ page: 'games' }, () => {
                // window.history.pushState(null, null, '/' + this.props.language.countryLanguageKey.toLowerCase().replace('_', '-') + route + '?recommend=true');
                this.props.history.push(route + '?recommend=true');
                window.scrollTo({ top: 0 });
            });
        }
    };

    handleBackMobile() {
        this.setState({ page: 'brand' }, () => {
            this.props.history.push('/slots');
        });
    }

    handleDropDownChange = (item, name) => {
        if (name === 'slotCategories') {
            if (this.isMount) {
                this.getSlotGames(item);
                this.setState({ dropDownItem1: item.toString() }, () => {
                    this.handleSearch('', this.state.dropDownItem1);
                    this.slotSorting(this.state.dropDownItem2);
                });
            }
        } else if (name === 'slotSort') {
            this.setState({ dropDownItem2: item.toString() }, () => {
                this.slotSorting(this.state.dropDownItem2);
            });
        }
    };

    handleSearch = (event, item) => {
        if (event && event.target) {
            this.getSlotGames(this.state.dropDownItem1, event.target.value);
            this.setState({ searchValue: event.target.value });
        } else {
            this.getSlotGames(item, this.state.searchValue);
        }
    };

    slotSorting = (name) => {
        this.setState({ isLoading: true });
        const { slotGamesList } = this.state;
        const { t } = this.props;

        console.log(name);

        let list = [];
        if (name === t('global:global.a_z')) {
            list = slotGamesList.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
            this.setState({ slotGamesList: list, isLoading: false });
        } else if (name === t('global:global.new_old')) {
            const { screen } = this.props;
            const { provider, slotGamesList, dropDownItem1 } = this.state;

            if (dropDownItem1 === 'ALL' || dropDownItem1 === 'HTML5') {
                window.SPL_Content.arrangeSlotNewToOld(screen.viewType, provider, slotGamesList).then((data) => {
                    this.setState({ slotGamesList: data, isLoading: false });
                });
            } else {
                list = slotGamesList.sort(function (a, b) {
                    return b.id - a.id;
                });
                this.setState({ slotGamesList: list, isLoading: false });
            }
        } else if (name === t('global:global.none')) {
            this.setState({ slotGamesList: slotGamesList, isLoading: false });
        } else {
            this.handleSearch('', this.state.dropDownItem1);
            this.setState({ isLoading: false });
        }
    };

    render() {
        const {
            page,
            menus,
            submenus,
            displaySubmenu,
            recommendSlideRow,
            brand,
            slotCategory,
            slotGamesList,
            provider,
            loading,
            isLoading,
            dropDownItem1,
            dropDownItem2,
            selectedGameObj,
        } = this.state;

        let slotsFunction = {
            page: page,
            menus: menus,
            submenus: submenus,
            displaySubmenu: displaySubmenu,
            recommendSlideRow: recommendSlideRow,
            brand: brand,
            slotCategory: slotCategory,
            slotGamesList: slotGamesList,
            provider: provider,
            loading: loading,
            isLoading: isLoading,
            dropDownItem1: dropDownItem1,
            dropDownItem2: dropDownItem2,
            handleDropDownChange: this.handleDropDownChange,
            getDisplayMenu: this.getDisplayMenu,
            getDisplaySubCategory: this.getDisplaySubCategory,
            init: this.init,
            getSlotGames: this.getSlotGames,
            navigateToHome: this.navigateToHome,
            onItemClick: this.onItemClick,
            handleBackMobile: this.handleBackMobile,
            updateMemberFavoriteGame: this.updateMemberFavoriteGame,
        };

        const { msgTitle, msgContent, detailModal, loginModal, applyContent } = this.state;

        let modalMsg = {
            msgTitle: msgTitle,
            msgContent: msgContent,
            detailModal: detailModal,
            loginModal: loginModal,
            applyContent: applyContent,
            toggleDetailModal: this.toggleDetailModal,
        };

        let screen = '';

        if (this.props.screen.isMobile) {
            screen = 'mobile';
        } else {
            screen = 'web';
        }

        let iosDevice = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);

        const mobileRecommend = this.props?.portal?.settings?.features?.enableRecommendGame?.includes(slotGamesList?.[0]?.category) && this.props?.screen?.isMobile;
        const isShowRecommend = this.props.location?.search?.includes('recommend');

        return (
            <Translation>
                {(t) => (
                    <div>
                        {this.state.loading && <Loading />}
                        {this.state.detailModal && <MessagePopUp modalMsg={modalMsg} />}
                        {screen === 'web' ? (
                            <Fragment>
                                <ul className='sort-box bg-gray web'>
                                    <li>
                                        <SortItem
                                            sortName='slotCategories'
                                            title={t('global:global.category', 'Categories')}
                                            value={this.state.dropDownItem1}
                                            items={this.state.slotCategory}
                                            slotsFunction={slotsFunction}
                                        />
                                    </li>
                                    <li>
                                        <SortItem
                                            sortName='slotSort'
                                            title={t('global:global.sort', 'Sort by')}
                                            value={t(this.state.dropDownItem2)}
                                            items={[t('global:global.none'), t('global:global.a_z'), t('global:global.new_old')]}
                                            slotsFunction={slotsFunction}
                                        />
                                        <div className='search-item-outer'>
                                            <div className='search-item'>
                                                <div className=''>
                                                    <SVGElements className='icon-search' name='search-icon' />
                                                    {/* <i className="icon-search"></i> */}
                                                    <input type='text' placeholder={t('global:global.search')} onChange={this.handleSearch} />
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                                <div className='sort-box-content web'>
                                    <BrandList slotsFunction={slotsFunction} onBrandChange={this.handleBrandChange} />
                                    <GameList slotsFunction={slotsFunction} />
                                </div>
                            </Fragment>
                        ) : (
                            screen === 'mobile' && (
                                // for mobile version
                                <div className={`mobile ${mobileRecommend && isShowRecommend ? 'mobileRecommend' : ''} page-${this.state.page}`} style={{ display: 'none' }}>
                                    {/* <CSSTransition
                                        in={this.state.page === 'brand'}
                                        className='brand-page'
                                        classNames='fade'
                                        timeout={300}
                                        unmountOnExit
                                    > */}
                                    {this.state.page === 'brand' && (
                                        <div>
                                            <span className='content-title'>{t('slot:slot.selectProvider', 'Select your lucky provider')}</span>
                                            <BrandList slotsFunction={slotsFunction} onBrandChange={this.handleBrandChangeMobile} />
                                        </div>
                                    )}
                                    {/* </CSSTransition> */}

                                    {/* <CSSTransition
                                        in={this.state.page === 'games'}
                                        className='games-page'
                                        classNames='fade'
                                        timeout={300}
                                        unmountOnExit
                                    > */}
                                    {this.state.page === 'games' && (
                                        <div>
                                            <div className='back-box'>
                                                <i
                                                    className='icon-back'
                                                    onClick={() => {
                                                        this.handleBackMobile();
                                                    }}
                                                ></i>
                                                <span>
                                                    <div className={'icon-box'}>
                                                        {/* <i className={"icon-" + this.state.brand}></i> */}
                                                        <SVG className={`icon-${this.state.brand}`} src={`/public/html/images/slot_img/icon-${this.state.brand}.svg`}>
                                                            {iosDevice && !['PT2', 'PT3', 'PT', 'AG2', 'AG', 'TTG'].includes(this.state.brand) ? (
                                                                <SVGElementsOwn
                                                                    className={`icon-${this.state.brand}${['NS', 'PP'].includes(this.state.brand) ? '-slot' : ''}`}
                                                                    name={'icon-' + this.state.brand}
                                                                />
                                                            ) : (
                                                                <SVGElements
                                                                    className={`icon-${this.state.brand}${['NS', 'PP'].includes(this.state.brand) ? '-slot' : ''}`}
                                                                    name={'icon-' + this.state.brand}
                                                                />
                                                            )}
                                                        </SVG>
                                                    </div>

                                                    {this.state.displaySubmenu.map(
                                                        (item, index) => this.state.brand === item.provider && <span key={item.provider}>{this.props.t(item.content)}</span>
                                                    )}
                                                </span>
                                            </div>

                                            <ul className='sort-box'>
                                                <li>
                                                    <SortItem
                                                        sortName='slotCategories'
                                                        title={t('global:global.category', 'Categories')}
                                                        value={this.state.dropDownItem1}
                                                        items={this.state.slotCategory}
                                                        slotsFunction={slotsFunction}
                                                    />
                                                </li>
                                                <li>
                                                    <SortItem
                                                        sortName='slotSort'
                                                        title={t('global:global.sort', 'Sort by')}
                                                        value={t(this.state.dropDownItem2)}
                                                        items={[t('global:global.none'), t('global:global.a_z'), t('global:global.new_old')]}
                                                        slotsFunction={slotsFunction}
                                                    />
                                                    <div className='search-item-outer'>
                                                        <div className='search-item'>
                                                            <div className=''>
                                                                <SVGElements className='icon-search' name='search-icon' />
                                                                {/* <i className="icon-search"></i> */}
                                                                <input type='text' placeholder={t('global:global.search')} onChange={this.handleSearch} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>

                                            <div className='sort-box-content'>
                                                <GameList slotsFunction={slotsFunction} selectedGameObj={selectedGameObj} />
                                            </div>
                                        </div>
                                    )}
                                    {/* </CSSTransition> */}
                                </div>
                            )
                        )}
                    </div>
                )}
            </Translation>
        );
    }
}

export default connect(mapStateToProps)(withTranslation()(withRouter(Search)));
